// extracted by mini-css-extract-plugin
export default {"messagesWrapper":"Messages_messagesWrapper__V6aHl","messagesScrollBtn":"Messages_messagesScrollBtn__sBWdn"};